import { useSelector } from 'react-redux'
import { preview } from '@/components/form/preview'
import { selectTerritoryLicensingLimits } from '@/features/domain/territory'

import { Address } from './components/Address'
import { BannedTags } from './components/BannedTags'
import { Barcodes } from './components/Barcodes'
import { Company } from './components/Company'
import { CustomFields } from './components/CustomFields'
import { Eligibility } from './components/Eligibility'
import { Email } from './components/Email'
import { Loads } from './components/Loads'
import { Priority } from './components/Priority'
import { Notes } from './components/Notes'
import { Phone } from './components/Phone'
import { RequiredTags } from './components/RequiredTags'
import { ServiceTime } from './components/ServiceTime'
import { TimeWindowExceptions } from './components/TimeWindowExceptions'
import { TimeWindows } from './components/TimeWindows'
import { Type } from './components/Type'
import { Vehicle } from './components/Vehicle'

import { useTexts } from './useTexts'
import { IntegrationData } from './components/IntegrationData'
interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
  showOrderPreviewModal?: (id: string, date: string) => void
  getRecurrentOrder?: (id: string, date: string) => Promise<void>
  isOpenedInOrderPreviewModal?: boolean
}

export function OrderConfigurationView(props: Props) {
  const { extOrder, showOrderPreviewModal, getRecurrentOrder, isOpenedInOrderPreviewModal } = props
  const texts = useTexts()

  const licensingLimits = useSelector(selectTerritoryLicensingLimits)
  const allowBarcodes = licensingLimits.trackedVehicles > 0

  // Hide loads for services (type 's')
  const showLoads: boolean = extOrder.orderStep.type !== 's'

  return (
    <>
      {extOrder.order.integrationData && (
        <>
          <IntegrationData extOrder={extOrder} />
          <preview.Divider />
        </>
      )}

      <Company extOrder={extOrder} />
      <preview.Divider />

      <Eligibility
        extOrder={extOrder}
        showOrderPreviewModal={showOrderPreviewModal}
        getRecurrentOrder={getRecurrentOrder}
        isOpenedInOrderPreviewModal={isOpenedInOrderPreviewModal}
      />
      <preview.Divider />

      {showLoads && (
        <>
          <Loads extOrder={extOrder} />
          <preview.Divider />
        </>
      )}

      <Vehicle extOrder={extOrder} />
      <preview.Divider />

      <Priority extOrder={extOrder} />
      <preview.Divider />

      <Type extOrder={extOrder} />
      <preview.Divider />

      <Address extOrder={extOrder} />
      <preview.Divider />

      <preview.Section spacing={3}>
        <preview.SectionTitle>{texts.contactInformation.title}</preview.SectionTitle>
        <Phone extOrder={extOrder} />
        <Email extOrder={extOrder} />
      </preview.Section>
      <preview.Divider />

      <preview.Section spacing={3}>
        <preview.SectionTitle>{texts.serviceTime.title}</preview.SectionTitle>
        <ServiceTime extOrder={extOrder} />
        <TimeWindows extOrder={extOrder} />
        <TimeWindowExceptions extOrder={extOrder} />
      </preview.Section>

      <preview.Divider />

      <preview.Section spacing={3}>
        <preview.SectionTitle>{texts.additionalDetails.title}</preview.SectionTitle>
        <RequiredTags extOrder={extOrder} />
        <BannedTags extOrder={extOrder} />
        <Notes extOrder={extOrder} />
        <CustomFields extOrder={extOrder} />
        {allowBarcodes && <Barcodes extOrder={extOrder} />}
      </preview.Section>
    </>
  )
}
